import React from "react";

const AlignLeftIcons = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M6 6h8m-8 4h12M6 14h8m-8 4h12"
      />
    </svg>
  );
};

export default AlignLeftIcons;
